<template>
  <line-chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import LineChart from '@/components/charts/LineChart'

export default {
  name: 'ReviewRequestChart',
  components: {
    LineChart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    },
    labelField: {
      type: String,
      default: 'date'
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.report.map(item => item[this.labelField]),
        datasets: [
          {
            label: '注文数',
            borderWidth: 2,
            pointRadius: 0,
            order: 2,  // 送信数グラフの下に描写する
            data: this.report.map(item => item.order),
            yAxisID: 'lineChart'
          },
          {
            label: 'レビューリクエスト送信数',
            borderWidth: 2,
            pointRadius: 0,
            order: 1,
            data: this.report.map(item => item.reviewRequest),
            yAxisID: 'lineChart'
          }
        ]
      }
    },
    options () {
      return {
        plugins: {
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                return `${label}: ${value}`
              }
            }
          }
        },
        maintainAspectRatio: false
      }
    }
  }

}
</script>

<style scoped>
</style>
